<template>
  <div ref="areaView" class="area-view">
    <ul v-show="areas.length > 0" 
        tabindex="0"
        @mouseenter="revealGeometriesDropdown()" 
        @mouseleave="hideGeometriesDropdown()">
        <li tabindex="0">
            <button role="button" class="areas-view-button" >
                User Areas <em>({{selectedArea.name}})</em>
            </button>
        </li>
        <li tabindex="0" v-for="area in areas" :key="`${area.name}`" v-show="showGeometriesDropdown">
            <md-radio v-model="selectedArea" :value="area">
                <span class="md-list-item-text">{{area.name}}</span>
            </md-radio>
            <md-button
            @click="changeColour(area)"
            :style="{ backgroundColor: area.colour }"
            class="md-icon-button md-raised"
            />
            <md-menu>
            <md-button class="md-icon-button" md-menu-trigger>
                <md-icon>more_vert</md-icon>
            </md-button>

            <md-menu-content>
                <md-menu-item @click="exportPolygons(area)">
                <md-icon>get_app</md-icon>
                <span>Export polygons</span>
                </md-menu-item>
                <md-menu-item @click="removeArea(area)">
                <md-icon>clear</md-icon>
                <span>Remove area</span>
                </md-menu-item>
            </md-menu-content>
            </md-menu>
        </li>
        <li tabindex="0" v-show="showGeometriesDropdown">
            <button role="button" title="Add new area" class="areas-view-button" @click="addArea(); ebxLogAnalytics(GA_EVENTS.BTN_ADD_AREA);">
                <span>Add area</span><md-icon>add</md-icon>
            </button>
        </li>
    </ul>
    <ColourPickerDialog ref="colourPickerDialog" @colour-selected="onColourChanged" />
  </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AreaService }  from '@/services/area.service'; 
import ColourPickerDialog from "@/components/ColourPickerDialog.vue";

export default {
  components: {
    ColourPickerDialog
  },
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    }
  },
    data() {
        return {
            areas: [],
            selectedArea: {},
            showGeometriesDropdown: false
        };
    },
  watch: {
    selectedArea(selectedArea) {
      AreaService.setSelectedArea(selectedArea.name, selectedArea.colour);
      this.$emit('input', selectedArea);
    }
  },
  methods: {
    revealGeometriesDropdown(){
        this.showGeometriesDropdown = true;
    },
    hideGeometriesDropdown(){
        this.showGeometriesDropdown = false;
    },
    addArea(areaName) {
        let newArea = {};

        let newAreaNumber = this.getNewAreaNumber() + 1;
        let colours = this.$refs.colourPickerDialog.colours;
        let colour = colours[((newAreaNumber-1) * 3) % colours.length];

        if (areaName) {
            newArea = {
                name: areaName,
                colour: colour
            };
        } else {
            newArea = {
                name: `Area ${newAreaNumber}`,
                colour: colour
            };
        }

        this.areas.push(newArea);

        AreaService.addArea(newArea.name, newArea.colour);

        this.selectedArea = newArea;
        
        
    },
    getNewAreaNumber() {
        let highestNumber = 0;
        let lastAreaElement = {}
        
        if (this.areas.length > 1) {
            lastAreaElement = this.areas[this.areas.length - 1];
            highestNumber = lastAreaElement.name.split(' ')[1]
            highestNumber = Number(highestNumber)
        } else if (this.areas.length === 1) {
            lastAreaElement = this.areas[0]
            highestNumber = lastAreaElement.name.split(' ')[1]
            highestNumber = Number(highestNumber)
        }
        return highestNumber;
    },
    removeArea(area){
        let areaIndex = this.areas.indexOf(area);
        if(area.name === this.selectedArea.name){
            this.selectedArea = {};
        }

        AreaService.removeArea({
          id: area.name,
          colour: area.colour
        });
        for(var i=0; i < this.areas.length; i++){
            if(this.areas[i].name === area.name){
            this.areas.splice(i, 1);
            }
        }

        if(this.areas.length === 0) {
            this.selectedArea = {};
        } else if(areaIndex !== 0) {
                this.selectedArea = this.areas[areaIndex - 1]
        } else {
            this.selectedArea = this.areas[0]
        }
    },
    changeColour(model) {
      this.$refs.colourPickerDialog.showDialog(model);
    },  
    onColourChanged(changedArea) {
      console.log("colour changed", changedArea);
      let area = {
        id: changedArea.name,
        colour: changedArea.colour
      }
      AreaService.updateArea(area)   
    },
    exportPolygons(area) {
        let name = area.name;
        let polygons = AreaService.getShapesForArea(name);

        // get only polgyons that have type UserDrawn, and get the overlay
        let userDrawnPolygons = polygons.filter(polygon => polygon.type === 'UserDrawn');
        userDrawnPolygons = userDrawnPolygons.map(polygon => polygon.overlay);

        // create a new google maps Data object, which we'll then use to create geojson
        let polygonData = new this.google.maps.Data();

        if(!userDrawnPolygons.length > 0) {
            return;
        }

        userDrawnPolygons.forEach(polygon => { // this needs to be updated if more geometry types get added to the map
            var coords;
            // rectangle
            try {
                let bounds = polygon.getBounds();
                let NE = bounds.getNorthEast();
                let SW = bounds.getSouthWest();
                let NW = new this.google.maps.LatLng(NE.lat(), SW.lng());
                let SE = new this.google.maps.LatLng(SW.lat(), NE.lng());
            
                coords = [NE, NW, SW, SE];
            } catch (e) { // polygon
                coords = polygon.getPath().getArray();
            }
          
            // add to data object
            polygonData.add(new this.google.maps.Data.Feature({
                geometry: new this.google.maps.Data.Polygon([coords])
            }))
        })
          
        // export data to geojson
        polygonData.toGeoJson(function(json) {
            let string = JSON.stringify(json);
            let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(string);
            let downloadAnchorNode = document.createElement('a');
            
            downloadAnchorNode.setAttribute("href", dataStr);
            let fileName = prompt('Please name the file being downloaded:')
            if(!fileName || fileName === '') {
                fileName = 'polygons';
            }

            downloadAnchorNode.setAttribute("download", `${fileName}.geojson`);
            document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        })
    }
  },
  mounted() {
    const areaView = this.$refs.areaView;
    this.map.controls[this.google.maps.ControlPosition.LEFT_TOP].push(areaView);

    this.clearAreasSubscription = AreaService.clearAreas$.subscribe(function() {
        this.areas = [];
    }.bind(this));

    this.userUploadedShapesSubscription = AreaService.userUploadedShape$.subscribe((shape) => {
      console.log("user uploaded shape event", shape);
      // when a user uploads a shape, we need to check if it has an area to be assigned to
      // if it doesn't, we need to create a new area and assign it to that
      // we then
      if(!shape.areaID) {
        // creates a new area
        this.addArea()

        // gets area id and updates shape to have that id
        shape.areaID = this.selectedArea.name;
        AreaService.updateShape(shape);
      }

      // gets colour shape should be
      let shapeColour = AreaService.getColour(shape.areaID);

      // add shape to map
      AreaService.setShapeOnMap(shape, this.map, this.google, shapeColour);

      // shift map to bounding box of shape
      if(shape.bbox) {
        let bounds = new this.google.maps.LatLngBounds(
          new this.google.maps.LatLng({lng: shape.bbox['SW'][0], lat: shape.bbox['SW'][1]}),
          new this.google.maps.LatLng({lng: shape.bbox['NE'][0], lat: shape.bbox['NE'][1]})
        );

        this.map.fitBounds(bounds)
      }
    })


  },
    beforeDestroy() {
        this.clearAreasSubscription.unsubscribe();
        this.userUploadedShapesSubscription.unsubscribe();
    }
};
</script>

<style lang="scss" scoped>
ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 13px;
    font-family: 'Montserrat', sans-serif;
    padding-inline-start: 20px;
    li {
        
        display: flex;
        align-items: center;
        span {
            min-width: 50px;
        }
        .md-radio {
            margin: 10px 10px 10px 0;
        }
    }
}
.area-view {
  
  .md-icon-button {
    width: 30px;
    min-width: 30px;
    height: 30px;
    margin: 0 6px;
  }
}

.md-list-item-content > .md-radio:first-child {
  margin-right: 10px;
}
</style>

<style>
.area-view {
  padding-left: 2px;
}

.area-view .md-list.md-dense .md-list-item-content {
  padding-right: 5px;
}

.area-view > .md-button {
  background-color: #ffff;
  box-shadow: #0000004d 0px 1px 4px -1px;
}

.area-view > .md-list {
  margin-left: 8px;
  background-color: transparent;
  background: transparent;
}
</style>
